module.exports = __webpack_public_path__ + "static/media/olympic.34c43479.png";